import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldOff } from 'lucide-react';

export function InstitutionFeatureBlocked({
  className,
  reason = 'menu',
}: {
  className?: string;
  /** `segment` : fonctionnalité absente pour ce type d’établissement (éducation / entreprise). */
  reason?: 'menu' | 'segment';
}) {
  const { t } = useTranslation();
  return (
    <div
      className={
        className ??
        'mx-auto flex max-w-md flex-col items-center gap-4 rounded-2xl border border-amber-200/80 bg-amber-50/90 px-6 py-10 text-center dark:border-amber-900/50 dark:bg-amber-950/30'
      }
      role="status"
    >
      <ShieldOff className="h-12 w-12 text-amber-600 dark:text-amber-400" aria-hidden />
      <div>
        <h2 className="text-lg font-semibold text-[#0C1C38] dark:text-white">
          {t('institution.menuBlocked.title', 'Fonctionnalité non disponible')}
        </h2>
        <p className="mt-2 text-sm text-[#5B6472] dark:text-[#B6CAEC]">
          {reason === 'segment'
            ? t(
                'institution.menuBlocked.segmentBody',
                'Cette fonctionnalité n’est pas proposée pour votre type d’établissement.',
              )
            : t(
                'institution.menuBlocked.body',
                'Cette section a été désactivée pour votre établissement par l’administrateur de la plateforme. Si vous pensez qu’il s’agit d’une erreur, contactez votre administrateur.',
              )}
        </p>
      </div>
    </div>
  );
}
